/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransactionPartImpl
 */
export interface TransactionPartImpl {
    /**
     * 
     * @type {Date}
     * @memberof TransactionPartImpl
     */
    transactionDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof TransactionPartImpl
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionPartImpl
     */
    careProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionPartImpl
     */
    careProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionPartImpl
     */
    careUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionPartImpl
     */
    careUnitId?: string;
}

export function TransactionPartImplFromJSON(json: any): TransactionPartImpl {
    return TransactionPartImplFromJSONTyped(json, false);
}

export function TransactionPartImplFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionPartImpl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionDate': !exists(json, 'transactionDate') ? undefined : (new Date(json['transactionDate'])),
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'careProvider': !exists(json, 'careProvider') ? undefined : json['careProvider'],
        'careProviderId': !exists(json, 'careProviderId') ? undefined : json['careProviderId'],
        'careUnit': !exists(json, 'careUnit') ? undefined : json['careUnit'],
        'careUnitId': !exists(json, 'careUnitId') ? undefined : json['careUnitId'],
    };
}

export function TransactionPartImplToJSON(value?: TransactionPartImpl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionDate': value.transactionDate === undefined ? undefined : (value.transactionDate.toISOString().substr(0,10)),
        'amount': value.amount,
        'careProvider': value.careProvider,
        'careProviderId': value.careProviderId,
        'careUnit': value.careUnit,
        'careUnitId': value.careUnitId,
    };
}

